import React from 'react';
import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const QuickLinks: React.FC = () => {
    return (
        <Box mt={6}>
            <Typography variant="h5" gutterBottom>
                Quick Links
            </Typography>
            <Divider sx={{ mb: 2, width: 140 }} />
            <Grid container spacing={2}>
                <Grid item>
                    <Button variant="outlined" component={Link} to="/admin/products" size="large">
                        Products List
                    </Button>
                </Grid>
                <Grid item>
                    <Button variant="outlined" component={Link} to="/admin/categories" size="large">
                        Categories
                    </Button>
                </Grid>
                <Grid item>
                    <Button variant="outlined" component={Link} to="/admin/recipes" size="large">
                        Recipes
                    </Button>
                </Grid>
                <Grid item>
                    <Button variant="outlined" component={Link} to="/admin/prices" size="large">
                        Prices
                    </Button>
                </Grid>
                <Grid item>
                    <Button variant="outlined" component={Link} to="/admin/openfoodfacts" size="large">
                        Open Food Facts
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default QuickLinks;